module.exports = __webpack_public_path__ + "img/FR40618.96fc807e.png";